import { Package } from '@/types/residents/package';
import dayjs from 'dayjs';

export const packages: Package[] = [
  {
    id: 'PKG001',
    type: 'regular',
    status: 'notified',
    trackingNumber: 'TRK123456789',
    deliveryService: 'fedex',
    resident: {
      id: 'RES001',
      name: 'John Doe'
    },
    receivedAt: dayjs('2024-03-15T10:00:00').toDate(),
    expiryDate: dayjs('2024-03-22T10:00:00').toDate(),
    description: 'Amazon Prime Delivery',
    sender: {
      name: 'Amazon',
      phone: '1-800-AMAZON'
    },
    attachments: [
      {
        id: 'ATT001',
        name: 'Package Photo',
        type: 'image',
        size: 1024,
        path: '/documents/packages/PKG001/photo.jpg',
        url: '/documents/packages/PKG001/photo.jpg',
        uploadedAt: dayjs('2024-03-15').toDate()
      }
    ]
  },
  {
    id: 'PKG002',
    type: 'fragile',
    status: 'collected',
    trackingNumber: 'TRK987654321',
    deliveryService: 'ups',
    resident: {
      id: 'RES002',
      name: 'Jane Smith'
    },
    receivedAt: dayjs('2024-03-14T14:30:00').toDate(),
    collectedAt: dayjs('2024-03-16T09:15:00').toDate(),
    expiryDate: dayjs('2024-03-21T14:30:00').toDate(),
    description: 'Glass Vase - Handle with Care',
    sender: {
      name: 'Pottery Barn',
      phone: '1-800-POTTERY'
    }
  },
  {
    id: 'PKG003',
    type: 'oversized',
    status: 'pending',
    trackingNumber: 'TRK456789123',
    deliveryService: 'usps',
    resident: {
      id: 'RES003',
      name: 'Mike Johnson'
    },
    receivedAt: dayjs('2024-03-16T11:45:00').toDate(),
    expiryDate: dayjs('2024-03-23T11:45:00').toDate(),
    description: 'Office Chair - Assembly Required',
    sender: {
      name: 'Office Depot',
      phone: '1-800-OFFICE'
    }
  },
  {
    id: 'PKG004',
    type: 'regular',
    status: 'expired',
    trackingNumber: 'TRK789123456',
    deliveryService: 'fedex',
    resident: {
      id: 'RES004',
      name: 'Sarah Wilson'
    },
    receivedAt: dayjs('2024-03-10T16:20:00').toDate(),
    expiryDate: dayjs('2024-03-17T16:20:00').toDate(),
    description: 'Clothing Package',
    sender: {
      name: 'Zara',
      phone: '1-800-ZARA'
    }
  },
  {
    id: 'PKG005',
    type: 'fragile',
    status: 'notified',
    trackingNumber: 'TRK321654987',
    deliveryService: 'ups',
    resident: {
      id: 'RES005',
      name: 'David Brown'
    },
    receivedAt: dayjs('2024-03-17T13:00:00').toDate(),
    expiryDate: dayjs('2024-03-24T13:00:00').toDate(),
    description: 'Electronics - Laptop',
    sender: {
      name: 'Best Buy',
      phone: '1-800-BESTBUY'
    }
  },
  {
    id: 'PKG006',
    type: 'oversized',
    status: 'collected',
    trackingNumber: 'TRK147258369',
    deliveryService: 'usps',
    resident: {
      id: 'RES006',
      name: 'Lisa Davis'
    },
    receivedAt: dayjs('2024-03-13T09:30:00').toDate(),
    collectedAt: dayjs('2024-03-15T17:45:00').toDate(),
    expiryDate: dayjs('2024-03-20T09:30:00').toDate(),
    description: 'Furniture - Coffee Table',
    sender: {
      name: 'IKEA',
      phone: '1-800-IKEA'
    }
  },
  {
    id: 'PKG007',
    type: 'regular',
    status: 'pending',
    trackingNumber: 'TRK963852741',
    deliveryService: 'fedex',
    resident: {
      id: 'RES007',
      name: 'Robert Taylor'
    },
    receivedAt: dayjs('2024-03-18T12:15:00').toDate(),
    expiryDate: dayjs('2024-03-25T12:15:00').toDate(),
    description: 'Books - Educational Materials',
    sender: {
      name: 'Barnes & Noble',
      phone: '1-800-BOOKS'
    }
  },
  {
    id: 'PKG008',
    type: 'fragile',
    status: 'notified',
    trackingNumber: 'TRK852963741',
    deliveryService: 'ups',
    resident: {
      id: 'RES008',
      name: 'Maria Garcia'
    },
    receivedAt: dayjs('2024-03-16T15:45:00').toDate(),
    expiryDate: dayjs('2024-03-23T15:45:00').toDate(),
    description: 'Art Supplies - Paint Set',
    sender: {
      name: 'Michaels',
      phone: '1-800-MICHAELS'
    }
  },
  {
    id: 'PKG009',
    type: 'oversized',
    status: 'collected',
    trackingNumber: 'TRK741852963',
    deliveryService: 'usps',
    resident: {
      id: 'RES009',
      name: 'James Wilson'
    },
    receivedAt: dayjs('2024-03-12T10:00:00').toDate(),
    collectedAt: dayjs('2024-03-14T14:30:00').toDate(),
    expiryDate: dayjs('2024-03-19T10:00:00').toDate(),
    description: 'Exercise Equipment - Treadmill',
    sender: {
      name: 'Dick\'s Sporting Goods',
      phone: '1-800-DICKS'
    }
  },
  {
    id: 'PKG010',
    type: 'regular',
    status: 'expired',
    trackingNumber: 'TRK369258147',
    deliveryService: 'fedex',
    resident: {
      id: 'RES010',
      name: 'Thomas Anderson'
    },
    receivedAt: dayjs('2024-03-09T08:30:00').toDate(),
    expiryDate: dayjs('2024-03-16T08:30:00').toDate(),
    description: 'Kitchen Appliances',
    sender: {
      name: 'Williams-Sonoma',
      phone: '1-800-WILLIAMS'
    }
  },
  {
    id: 'PKG011',
    type: 'fragile',
    status: 'pending',
    trackingNumber: 'TRK258147369',
    deliveryService: 'ups',
    resident: {
      id: 'RES011',
      name: 'Emily Chen'
    },
    receivedAt: dayjs('2024-03-19T11:20:00').toDate(),
    expiryDate: dayjs('2024-03-26T11:20:00').toDate(),
    description: 'Jewelry - Engagement Ring',
    sender: {
      name: 'Tiffany & Co.',
      phone: '1-800-TIFFANY'
    }
  },
  {
    id: 'PKG012',
    type: 'oversized',
    status: 'notified',
    trackingNumber: 'TRK147369258',
    deliveryService: 'usps',
    resident: {
      id: 'RES012',
      name: 'Christopher Lee'
    },
    receivedAt: dayjs('2024-03-17T16:45:00').toDate(),
    expiryDate: dayjs('2024-03-24T16:45:00').toDate(),
    description: 'Home Theater System',
    sender: {
      name: 'Crutchfield',
      phone: '1-800-CRUTCHFIELD'
    }
  },
  {
    id: 'PKG013',
    type: 'regular',
    status: 'collected',
    trackingNumber: 'TRK963147258',
    deliveryService: 'fedex',
    resident: {
      id: 'RES013',
      name: 'Amanda Rodriguez'
    },
    receivedAt: dayjs('2024-03-14T13:15:00').toDate(),
    collectedAt: dayjs('2024-03-16T10:30:00').toDate(),
    expiryDate: dayjs('2024-03-21T13:15:00').toDate(),
    description: 'Cosmetics - Makeup Set',
    sender: {
      name: 'Sephora',
      phone: '1-800-SEPHORA'
    }
  },
  {
    id: 'PKG014',
    type: 'fragile',
    status: 'expired',
    trackingNumber: 'TRK852147963',
    deliveryService: 'ups',
    resident: {
      id: 'RES014',
      name: 'Daniel Kim'
    },
    receivedAt: dayjs('2024-03-08T14:00:00').toDate(),
    expiryDate: dayjs('2024-03-15T14:00:00').toDate(),
    description: 'Wine Collection',
    sender: {
      name: 'Wine.com',
      phone: '1-800-WINE'
    }
  },
  {
    id: 'PKG015',
    type: 'oversized',
    status: 'pending',
    trackingNumber: 'TRK741963852',
    deliveryService: 'usps',
    resident: {
      id: 'RES015',
      name: 'Jessica Martinez'
    },
    receivedAt: dayjs('2024-03-20T09:45:00').toDate(),
    expiryDate: dayjs('2024-03-27T09:45:00').toDate(),
    description: 'Garden Tools Set',
    sender: {
      name: 'Home Depot',
      phone: '1-800-HOMEDEPOT'
    }
  },
  {
    id: 'PKG016',
    type: 'regular',
    status: 'notified',
    trackingNumber: 'TRK369852741',
    deliveryService: 'fedex',
    resident: {
      id: 'RES016',
      name: 'Ryan Thompson'
    },
    receivedAt: dayjs('2024-03-18T15:30:00').toDate(),
    expiryDate: dayjs('2024-03-25T15:30:00').toDate(),
    description: 'Pet Supplies - Dog Food',
    sender: {
      name: 'Chewy',
      phone: '1-800-CHEWY'
    }
  },
  {
    id: 'PKG017',
    type: 'fragile',
    status: 'collected',
    trackingNumber: 'TRK258963741',
    deliveryService: 'ups',
    resident: {
      id: 'RES017',
      name: 'Nicole White'
    },
    receivedAt: dayjs('2024-03-13T12:00:00').toDate(),
    collectedAt: dayjs('2024-03-15T16:20:00').toDate(),
    expiryDate: dayjs('2024-03-20T12:00:00').toDate(),
    description: 'Musical Instruments - Guitar',
    sender: {
      name: 'Guitar Center',
      phone: '1-800-GUITAR'
    }
  },
  {
    id: 'PKG018',
    type: 'oversized',
    status: 'expired',
    trackingNumber: 'TRK147258963',
    deliveryService: 'usps',
    resident: {
      id: 'RES018',
      name: 'Kevin Johnson'
    },
    receivedAt: dayjs('2024-03-07T10:30:00').toDate(),
    expiryDate: dayjs('2024-03-14T10:30:00').toDate(),
    description: 'Camping Equipment',
    sender: {
      name: 'REI',
      phone: '1-800-REI'
    }
  },
  {
    id: 'PKG019',
    type: 'regular',
    status: 'pending',
    trackingNumber: 'TRK963741258',
    deliveryService: 'fedex',
    resident: {
      id: 'RES019',
      name: 'Rachel Green'
    },
    receivedAt: dayjs('2024-03-21T11:15:00').toDate(),
    expiryDate: dayjs('2024-03-28T11:15:00').toDate(),
    description: 'Baby Products - Diapers',
    sender: {
      name: 'Target',
      phone: '1-800-TARGET'
    }
  },
  {
    id: 'PKG020',
    type: 'fragile',
    status: 'notified',
    trackingNumber: 'TRK852369741',
    deliveryService: 'ups',
    resident: {
      id: 'RES020',
      name: 'Michael Scott'
    },
    receivedAt: dayjs('2024-03-19T14:45:00').toDate(),
    expiryDate: dayjs('2024-03-26T14:45:00').toDate(),
    description: 'Photography Equipment',
    sender: {
      name: 'B&H Photo',
      phone: '1-800-BHPHOTO'
    }
  },
  {
    id: 'PKG021',
    type: 'oversized',
    status: 'collected',
    trackingNumber: 'TRK741258963',
    deliveryService: 'usps',
    resident: {
      id: 'RES021',
      name: 'Pam Beesly'
    },
    receivedAt: dayjs('2024-03-15T08:20:00').toDate(),
    collectedAt: dayjs('2024-03-17T13:40:00').toDate(),
    expiryDate: dayjs('2024-03-22T08:20:00').toDate(),
    description: 'Office Furniture - Desk',
    sender: {
      name: 'Staples',
      phone: '1-800-STAPLES'
    }
  },
  {
    id: 'PKG022',
    type: 'regular',
    status: 'expired',
    trackingNumber: 'TRK369741852',
    deliveryService: 'fedex',
    resident: {
      id: 'RES022',
      name: 'Jim Halpert'
    },
    receivedAt: dayjs('2024-03-06T16:00:00').toDate(),
    expiryDate: dayjs('2024-03-13T16:00:00').toDate(),
    description: 'Sports Equipment - Basketball',
    sender: {
      name: 'Nike',
      phone: '1-800-NIKE'
    }
  },
  {
    id: 'PKG023',
    type: 'fragile',
    status: 'pending',
    trackingNumber: 'TRK258741963',
    deliveryService: 'ups',
    resident: {
      id: 'RES023',
      name: 'Dwight Schrute'
    },
    receivedAt: dayjs('2024-03-22T10:30:00').toDate(),
    expiryDate: dayjs('2024-03-29T10:30:00').toDate(),
    description: 'Collectible Figurines',
    sender: {
      name: 'Hot Topic',
      phone: '1-800-HOTTOPIC'
    }
  },
  {
    id: 'PKG024',
    type: 'oversized',
    status: 'notified',
    trackingNumber: 'TRK147963258',
    deliveryService: 'usps',
    resident: {
      id: 'RES024',
      name: 'Angela Martin'
    },
    receivedAt: dayjs('2024-03-20T12:45:00').toDate(),
    expiryDate: dayjs('2024-03-27T12:45:00').toDate(),
    description: 'Cat Tree - Multi-level',
    sender: {
      name: 'PetSmart',
      phone: '1-800-PETSMART'
    }
  },
  {
    id: 'PKG025',
    type: 'regular',
    status: 'collected',
    trackingNumber: 'TRK963258741',
    deliveryService: 'fedex',
    resident: {
      id: 'RES025',
      name: 'Oscar Martinez'
    },
    receivedAt: dayjs('2024-03-16T09:15:00').toDate(),
    collectedAt: dayjs('2024-03-18T15:30:00').toDate(),
    expiryDate: dayjs('2024-03-23T09:15:00').toDate(),
    description: 'Cooking Utensils Set',
    sender: {
      name: 'Sur La Table',
      phone: '1-800-SURLATABLE'
    }
  },
  {
    id: 'PKG026',
    type: 'fragile',
    status: 'expired',
    trackingNumber: 'TRK852741963',
    deliveryService: 'ups',
    resident: {
      id: 'RES026',
      name: 'Stanley Hudson'
    },
    receivedAt: dayjs('2024-03-05T13:30:00').toDate(),
    expiryDate: dayjs('2024-03-12T13:30:00').toDate(),
    description: 'Crystal Decanter Set',
    sender: {
      name: 'Crate & Barrel',
      phone: '1-800-CRATEBARREL'
    }
  },
  {
    id: 'PKG027',
    type: 'oversized',
    status: 'pending',
    trackingNumber: 'TRK741963852',
    deliveryService: 'usps',
    resident: {
      id: 'RES027',
      name: 'Phyllis Vance'
    },
    receivedAt: dayjs('2024-03-23T11:00:00').toDate(),
    expiryDate: dayjs('2024-03-30T11:00:00').toDate(),
    description: 'Sewing Machine',
    sender: {
      name: 'JoAnn Fabrics',
      phone: '1-800-JOANN'
    }
  },
  {
    id: 'PKG028',
    type: 'regular',
    status: 'notified',
    trackingNumber: 'TRK369852741',
    deliveryService: 'fedex',
    resident: {
      id: 'RES028',
      name: 'Bob Vance'
    },
    receivedAt: dayjs('2024-03-21T14:20:00').toDate(),
    expiryDate: dayjs('2024-03-28T14:20:00').toDate(),
    description: 'Auto Parts - Brake Pads',
    sender: {
      name: 'AutoZone',
      phone: '1-800-AUTOZONE'
    }
  },
  {
    id: 'PKG029',
    type: 'fragile',
    status: 'collected',
    trackingNumber: 'TRK258963741',
    deliveryService: 'ups',
    resident: {
      id: 'RES029',
      name: 'Creed Bratton'
    },
    receivedAt: dayjs('2024-03-17T10:45:00').toDate(),
    collectedAt: dayjs('2024-03-19T16:15:00').toDate(),
    expiryDate: dayjs('2024-03-24T10:45:00').toDate(),
    description: 'Antique Clock',
    sender: {
      name: 'Antique Store',
      phone: '1-800-ANTIQUE'
    }
  },
  {
    id: 'PKG030',
    type: 'oversized',
    status: 'expired',
    trackingNumber: 'TRK147258963',
    deliveryService: 'usps',
    resident: {
      id: 'RES030',
      name: 'Meredith Palmer'
    },
    receivedAt: dayjs('2024-03-04T15:00:00').toDate(),
    expiryDate: dayjs('2024-03-11T15:00:00').toDate(),
    description: 'Beer Keg - Party Supplies',
    sender: {
      name: 'BevMo',
      phone: '1-800-BEVMO'
    }
  },
  {
    id: 'PKG031',
    type: 'regular',
    status: 'pending',
    trackingNumber: 'TRK963741258',
    deliveryService: 'fedex',
    resident: {
      id: 'RES031',
      name: 'Kelly Kapoor'
    },
    receivedAt: dayjs('2024-03-24T09:30:00').toDate(),
    expiryDate: dayjs('2024-03-31T09:30:00').toDate(),
    description: 'Fashion Accessories',
    sender: {
      name: 'Forever 21',
      phone: '1-800-FOREVER21'
    }
  },
  {
    id: 'PKG032',
    type: 'fragile',
    status: 'notified',
    trackingNumber: 'TRK852369741',
    deliveryService: 'ups',
    resident: {
      id: 'RES032',
      name: 'Toby Flenderson'
    },
    receivedAt: dayjs('2024-03-22T13:15:00').toDate(),
    expiryDate: dayjs('2024-03-29T13:15:00').toDate(),
    description: 'Self-Help Books',
    sender: {
      name: 'Amazon Books',
      phone: '1-800-AMAZON'
    }
  },
  {
    id: 'PKG033',
    type: 'oversized',
    status: 'collected',
    trackingNumber: 'TRK741258963',
    deliveryService: 'usps',
    resident: {
      id: 'RES033',
      name: 'Andy Bernard'
    },
    receivedAt: dayjs('2024-03-18T11:45:00').toDate(),
    collectedAt: dayjs('2024-03-20T17:30:00').toDate(),
    expiryDate: dayjs('2024-03-25T11:45:00').toDate(),
    description: 'Musical Equipment - Drums',
    sender: {
      name: 'Sam Ash',
      phone: '1-800-SAMASH'
    }
  },
  {
    id: 'PKG034',
    type: 'regular',
    status: 'expired',
    trackingNumber: 'TRK369741852',
    deliveryService: 'fedex',
    resident: {
      id: 'RES034',
      name: 'Darryl Philbin'
    },
    receivedAt: dayjs('2024-03-03T12:30:00').toDate(),
    expiryDate: dayjs('2024-03-10T12:30:00').toDate(),
    description: 'Work Boots',
    sender: {
      name: 'Work Boots USA',
      phone: '1-800-WORKBOOTS'
    }
  },
  {
    id: 'PKG035',
    type: 'fragile',
    status: 'pending',
    trackingNumber: 'TRK258741963',
    deliveryService: 'ups',
    resident: {
      id: 'RES035',
      name: 'Holly Flax'
    },
    receivedAt: dayjs('2024-03-25T10:00:00').toDate(),
    expiryDate: dayjs('2024-04-01T10:00:00').toDate(),
    description: 'Scented Candles Collection',
    sender: {
      name: 'Yankee Candle',
      phone: '1-800-YANKEE'
    }
  },
  {
    id: 'PKG036',
    type: 'oversized',
    status: 'notified',
    trackingNumber: 'TRK147963258',
    deliveryService: 'usps',
    resident: {
      id: 'RES036',
      name: 'Jan Levinson'
    },
    receivedAt: dayjs('2024-03-23T15:45:00').toDate(),
    expiryDate: dayjs('2024-03-30T15:45:00').toDate(),
    description: 'Yoga Equipment - Mat & Blocks',
    sender: {
      name: 'Lululemon',
      phone: '1-800-LULULEMON'
    }
  },
  {
    id: 'PKG037',
    type: 'regular',
    status: 'collected',
    trackingNumber: 'TRK963258741',
    deliveryService: 'fedex',
    resident: {
      id: 'RES037',
      name: 'David Wallace'
    },
    receivedAt: dayjs('2024-03-19T08:15:00').toDate(),
    collectedAt: dayjs('2024-03-21T14:45:00').toDate(),
    expiryDate: dayjs('2024-03-26T08:15:00').toDate(),
    description: 'Business Suit',
    sender: {
      name: 'Brooks Brothers',
      phone: '1-800-BROOKS'
    }
  },
  {
    id: 'PKG038',
    type: 'fragile',
    status: 'expired',
    trackingNumber: 'TRK852741963',
    deliveryService: 'ups',
    resident: {
      id: 'RES038',
      name: 'Charles Miner'
    },
    receivedAt: dayjs('2024-03-02T14:00:00').toDate(),
    expiryDate: dayjs('2024-03-09T14:00:00').toDate(),
    description: 'Fine China Set',
    sender: {
      name: 'Lenox',
      phone: '1-800-LENOX'
    }
  },
  {
    id: 'PKG039',
    type: 'oversized',
    status: 'pending',
    trackingNumber: 'TRK741963852',
    deliveryService: 'usps',
    resident: {
      id: 'RES039',
      name: 'Jo Bennett'
    },
    receivedAt: dayjs('2024-03-26T12:30:00').toDate(),
    expiryDate: dayjs('2024-04-02T12:30:00').toDate(),
    description: 'Garden Furniture Set',
    sender: {
      name: 'Wayfair',
      phone: '1-800-WAYFAIR'
    }
  },
  {
    id: 'PKG040',
    type: 'regular',
    status: 'notified',
    trackingNumber: 'TRK369852741',
    deliveryService: 'fedex',
    resident: {
      id: 'RES040',
      name: 'Gabe Lewis'
    },
    receivedAt: dayjs('2024-03-24T16:15:00').toDate(),
    expiryDate: dayjs('2024-03-31T16:15:00').toDate(),
    description: 'Tech Gadgets - Smart Watch',
    sender: {
      name: 'Apple Store',
      phone: '1-800-APPLE'
    }
  },
  {
    id: 'PKG041',
    type: 'fragile',
    status: 'collected',
    trackingNumber: 'TRK258963741',
    deliveryService: 'ups',
    resident: {
      id: 'RES041',
      name: 'Erin Hannon'
    },
    receivedAt: dayjs('2024-03-20T09:45:00').toDate(),
    collectedAt: dayjs('2024-03-22T15:20:00').toDate(),
    expiryDate: dayjs('2024-03-27T09:45:00').toDate(),
    description: 'Art Prints - Framed',
    sender: {
      name: 'Art.com',
      phone: '1-800-ART'
    }
  },
  {
    id: 'PKG042',
    type: 'oversized',
    status: 'expired',
    trackingNumber: 'TRK147258963',
    deliveryService: 'usps',
    resident: {
      id: 'RES042',
      name: 'Pete Miller'
    },
    receivedAt: dayjs('2024-03-01T11:30:00').toDate(),
    expiryDate: dayjs('2024-03-08T11:30:00').toDate(),
    description: 'Fitness Equipment - Weights',
    sender: {
      name: 'Fitness Depot',
      phone: '1-800-FITNESS'
    }
  },
  {
    id: 'PKG043',
    type: 'regular',
    status: 'pending',
    trackingNumber: 'TRK963741258',
    deliveryService: 'fedex',
    resident: {
      id: 'RES043',
      name: 'Clark Green'
    },
    receivedAt: dayjs('2024-03-27T10:15:00').toDate(),
    expiryDate: dayjs('2024-04-03T10:15:00').toDate(),
    description: 'Board Games Collection',
    sender: {
      name: 'GameStop',
      phone: '1-800-GAMESTOP'
    }
  },
  {
    id: 'PKG044',
    type: 'fragile',
    status: 'notified',
    trackingNumber: 'TRK852369741',
    deliveryService: 'ups',
    resident: {
      id: 'RES044',
      name: 'Nellie Bertram'
    },
    receivedAt: dayjs('2024-03-25T13:45:00').toDate(),
    expiryDate: dayjs('2024-04-01T13:45:00').toDate(),
    description: 'Perfume Collection',
    sender: {
      name: 'Macy\'s',
      phone: '1-800-MACYS'
    }
  },
  {
    id: 'PKG045',
    type: 'oversized',
    status: 'collected',
    trackingNumber: 'TRK741258963',
    deliveryService: 'usps',
    resident: {
      id: 'RES045',
      name: 'Robert California'
    },
    receivedAt: dayjs('2024-03-21T07:30:00').toDate(),
    collectedAt: dayjs('2024-03-23T13:15:00').toDate(),
    expiryDate: dayjs('2024-03-28T07:30:00').toDate(),
    description: 'Wine Cellar - Temperature Controlled',
    sender: {
      name: 'Wine Enthusiast',
      phone: '1-800-WINE'
    }
  },
  {
    id: 'PKG046',
    type: 'regular',
    status: 'expired',
    trackingNumber: 'TRK369741852',
    deliveryService: 'fedex',
    resident: {
      id: 'RES046',
      name: 'Cathy Simms'
    },
    receivedAt: dayjs('2024-02-29T15:00:00').toDate(),
    expiryDate: dayjs('2024-03-07T15:00:00').toDate(),
    description: 'Hair Care Products',
    sender: {
      name: 'Ulta Beauty',
      phone: '1-800-ULTA'
    }
  },
  {
    id: 'PKG047',
    type: 'fragile',
    status: 'pending',
    trackingNumber: 'TRK258741963',
    deliveryService: 'ups',
    resident: {
      id: 'RES047',
      name: 'Todd Packer'
    },
    receivedAt: dayjs('2024-03-28T11:00:00').toDate(),
    expiryDate: dayjs('2024-04-04T11:00:00').toDate(),
    description: 'Beer Brewing Kit',
    sender: {
      name: 'Northern Brewer',
      phone: '1-800-BREWER'
    }
  },
  {
    id: 'PKG048',
    type: 'oversized',
    status: 'notified',
    trackingNumber: 'TRK147963258',
    deliveryService: 'usps',
    resident: {
      id: 'RES048',
      name: 'Hank Tate'
    },
    receivedAt: dayjs('2024-03-26T14:30:00').toDate(),
    expiryDate: dayjs('2024-04-02T14:30:00').toDate(),
    description: 'Tool Set - Professional Grade',
    sender: {
      name: 'Snap-on Tools',
      phone: '1-800-SNAPON'
    }
  },
  {
    id: 'PKG049',
    type: 'regular',
    status: 'collected',
    trackingNumber: 'TRK963258741',
    deliveryService: 'fedex',
    resident: {
      id: 'RES049',
      name: 'Val Johnson'
    },
    receivedAt: dayjs('2024-03-22T08:45:00').toDate(),
    collectedAt: dayjs('2024-03-24T14:20:00').toDate(),
    expiryDate: dayjs('2024-03-29T08:45:00').toDate(),
    description: 'Sunglasses Collection',
    sender: {
      name: 'Ray-Ban',
      phone: '1-800-RAYBAN'
    }
  },
  {
    id: 'PKG050',
    type: 'fragile',
    status: 'expired',
    trackingNumber: 'TRK852741963',
    deliveryService: 'ups',
    resident: {
      id: 'RES050',
      name: 'Tony Gardner'
    },
    receivedAt: dayjs('2024-02-28T12:15:00').toDate(),
    expiryDate: dayjs('2024-03-06T12:15:00').toDate(),
    description: 'Vintage Vinyl Records',
    sender: {
      name: 'Record Store',
      phone: '1-800-RECORDS'
    }
  }
];

 